import type React from 'react'

export const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15, 23, 42, 0.55)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1200,
  padding: 16,
}

export const modalShellStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 520,
  background: '#fff',
  borderRadius: 14,
  boxShadow: '0 20px 60px rgba(15, 23, 42, 0.32)',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100vh - 32px)',
  overflow: 'hidden',
}

export const modalHeaderStyle: React.CSSProperties = {
  padding: '18px 22px',
  borderBottom: '1px solid #E5E7EB',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
}

export const modalBodyStyle: React.CSSProperties = {
  padding: '20px 22px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
}

export const modalFooterStyle: React.CSSProperties = {
  padding: '14px 22px',
  borderTop: '1px solid #E5E7EB',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 8,
  background: '#F9FAFB',
}

export const primaryBtnStyle: React.CSSProperties = {
  padding: '8px 16px',
  fontSize: 13,
  fontWeight: 600,
  color: '#fff',
  background: '#2563EB',
  border: 'none',
  borderRadius: 8,
  cursor: 'pointer',
  fontFamily: 'inherit',
}

export const ghostBtnStyle: React.CSSProperties = {
  padding: '8px 14px',
  fontSize: 13,
  fontWeight: 600,
  color: '#374151',
  background: 'transparent',
  border: '1px solid #D1D5DB',
  borderRadius: 8,
  cursor: 'pointer',
  fontFamily: 'inherit',
}

export const dangerBtnStyle: React.CSSProperties = {
  padding: '8px 16px',
  fontSize: 13,
  fontWeight: 600,
  color: '#fff',
  background: '#DC2626',
  border: 'none',
  borderRadius: 8,
  cursor: 'pointer',
  fontFamily: 'inherit',
}
